import LinkUpload from "../../../api/LinkUpload";
import moment from "moment";
import axiosClient from "../../../api/axios";
import { Image } from "antd";
import { FilePdfOutlined, FileWordOutlined, FileExcelOutlined } from "@ant-design/icons";


const token = localStorage.getItem('token');
const changeUpload = (formInstance, name, info, setFileList) => {
    const { fileList } = info;
    // Lấy đường dẫn thật từ server (res.data.FilePath)
    const dataImage = fileList
        .filter(f => f.status === "done")
        .map(file => {
            if (file.response?.FilePath) {
                return file.response.FilePath; // từ server
            }
            return file.url || ""; // fallback nếu đã có url
        })
        .filter(path => path !== ""); // loại bỏ rỗng

    const resultURL = dataImage.join(";");

    // Cập nhật form
    formInstance.setFieldsValue({ [name]: resultURL });

    // Cập nhật state
    setFileList(fileList);
};




const updateFileListFromUrls = (setFileList, urlsString) => {
    if (!urlsString) {
        setFileList([]); // Nếu không có URL, đặt danh sách file thành mảng rỗng
        return;
    }

    // Chia chuỗi URL bằng dấu ';' và loại bỏ chuỗi rỗng
    const urls = urlsString.split(";").filter(url => url.trim() !== "");
    const resualURL = urls.map(r => LinkUpload(r))
    // Tạo fileList phù hợp với cấu trúc của Ant Design
    const fileList = resualURL.map((url, index) => ({
        uid: `file-${index}`, // Tạo `uid` duy nhất
        name: url.split("/").pop(), // Lấy tên file từ URL
        url, // Gán URL cho thuộc tính `url`
        status: "done", // Đánh dấu là đã tải lên thành công
    }));

    // Cập nhật danh sách file
    setFileList(fileList);
};
const uploadImage = async ({ onSuccess, onError, file, onProgress }) => {
    try {
        const fmData = new FormData();

        // Đổi tên file: timestamp_filename.ext
        const renamedFile = new File(
            [file],
            `${moment().valueOf()}_${file.name}`,
            { type: file.type }
        );
        fmData.append("file", renamedFile);

        // Dựa vào file.type để chọn endpoint
        let endpoint = "/uploadfile"; // default
        if (file.type.startsWith("video")) {
            endpoint = "/uploadvideo";
        } else if (file.type.startsWith("image")) {
            endpoint = "/uploadfile";
        }

        const res = await axiosClient.post(endpoint, fmData, {
            headers: {
                "content-type": "multipart/form-data",
                Accept: "application/json",
                Authorization: `Bearer ${token}`,
            },
            onUploadProgress: ({ loaded, total }) => {
                if (total) {
                    onProgress?.({
                        percent: Math.round((loaded / total) * 100),
                    });
                }
            },
        });

        onSuccess?.(res.data);
    } catch (error) {
        console.error("Upload error:", error);
        onError?.(error);
    }
}

const getFilePreview = (file) => {
    const fileType = file.type || file.name.split('.').pop().toLowerCase();

    if (fileType.includes("image")) {
        return <Image src={URL.createObjectURL(file)} width={50} />;
    }
    if (fileType.includes("pdf")) {
        return <FilePdfOutlined style={{ fontSize: 50, color: "red" }} />;
    }
    if (fileType.includes("doc") || fileType.includes("word")) {
        return <FileWordOutlined style={{ fontSize: 50, color: "blue" }} />;
    }
    if (fileType.includes("xls") || fileType.includes("excel")) {
        return <FileExcelOutlined style={{ fontSize: 50, color: "green" }} />;
    }
    return "📄"; // Icon mặc định cho file khác
};

const beforeUpload = (file) => {
    // Tạo file mới với tên mới
    const newFile = new File([file], moment().toDate().valueOf() + `${file.name}`, { type: file.type });
    return newFile;
}
export { changeUpload, updateFileListFromUrls, uploadImage, beforeUpload, getFilePreview }
